'use client';

import 'i18n';
import 'moment/locale/de';

import { CookieWrapper } from 'components/CookieWrapper';
import { useParams } from 'next/navigation';
import { Provider } from 'react-redux';
import store from 'redux/store';
import { ThemeProvider } from 'styled-components';
import { SWRConfig } from 'swr';
import theme from 'theme';
import RestoreAuth from '~/components/auth/RestoreAuth';
import ClubContext from '~/components/ClubContext';
import EmailVerificationBanner from '~/components/EmailVerificationBanner';
import FloatingPortal from '~/components/FloatingPortal';
import GlobalOverlay from '~/components/GlobalOverlay';
import ModalManager from '~/components/ModalManager';
import ToastManager from '~/components/ToastManager/ToastManager';
import { swrRetryPolicy } from '~/lib/apiErrors';
import { swrFetcher } from '~/lib/swr-fetcher';

/**
 * Everything the app itself runs inside: store, data, theme, every translation, the
 * consent banner, the global managers. What the root layout used to be, unchanged —
 * only no longer loaded for club websites (see RootShell).
 */
export default function AppShell({ children }: { children: React.ReactNode }) {
    const params = useParams();

    return (
        <ThemeProvider theme={theme}>
            <SWRConfig value={{ fetcher: swrFetcher, ...swrRetryPolicy }}>
                <Provider store={store}>
                    <CookieWrapper>
                        <ClubContext.Provider
                            value={Array.isArray(params?.slug) ? params.slug[0] : (params?.slug as string)}
                        >
                            <EmailVerificationBanner />
                            <main>{children}</main>
                            <ToastManager />
                            <ModalManager />
                            <FloatingPortal />
                            <RestoreAuth />

                            <GlobalOverlay />
                        </ClubContext.Provider>
                    </CookieWrapper>
                </Provider>
            </SWRConfig>
        </ThemeProvider>
    );
}
